import { render } from "./DosageSelect.vue?vue&type=template&id=7bc20e0b&scoped=true"
import script from "./DosageSelect.vue?vue&type=script&lang=js"
export * from "./DosageSelect.vue?vue&type=script&lang=js"

import "./DosageSelect.vue?vue&type=style&index=0&id=7bc20e0b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bc20e0b"]])

export default __exports__